/**
 * enum for setting block alignment, used by setAlignment API
 */
export enum CompatibleAlignment {

    /**
     * Align left
     */
    Left,

    /**
     * Align center
     */
    Center,

    /**
     * Align right
     */
    Right,
}
